import React, { useState } from "react";
import HideableBox from "../components/Generic/HideableBox";
import ProfileImage from "../components/ProfileImage";
import Home from "./Home";
import "../pages/Edit.css";
import { EditEmail } from "../components/Auth/EditEmail";
import Popup from "reactjs-popup";
// import DivButton from "../components/Generic/DivButton";
import { LegalDoc } from "../components/LegalDoc";
const myReq = require("../Requests.js");

export function EditAccount(props) {
  const [openConfirm, setOpenConfirm] = useState(false);
  const closeConfirmModal = () => setOpenConfirm(false);
  const [emailOffers, setEmailOffers] = useState(false);
  const profileData = props.profileData;

  let StillActive = props.profileData.Subscribed.Active;
  let willRenew = props.profileData.Subscribed.Renew;

  function afterSubmit() {
    window.location.href = "/edit";
  }
  function CancelSub() {
    let UserID = props.userNameKey;
    let SubID = props.profileData.Subscribed.subID;
    // console.log(UserID);
    myReq.cancelSUb(UserID, SubID, afterSubmit);
  }
  // logUser();
  const handleValue = () => {};
  let count = -1;
  return (
    <>
      <h2>Account</h2>
      <div className="hoverBox OverviewContainer">
        <h3>General:</h3>
        <HideableBox
          label="Email Settings"
          ClassList="EditSection"
          hiddenByDefault={true}
        >
          <div className="EditLineItem">
            <h2>Email Settings:</h2>
          </div>
          <div className="EditLineItem">
            <span>Email:</span>
            <div>{props.user.attributes.email}</div>
          </div>
          <HideableBox hiddenByDefault={true} label="Edit Email Address">
            <EditEmail signOut={props.signOut}></EditEmail>
          </HideableBox>

          <div className="EditLineItem">
            <span>Receive email updates and offers </span>
            <div>
              {emailOffers ? "Yes " : "No "}
              <input
                type="checkbox"
                onChange={() => {
                  setEmailOffers(!emailOffers);
                }}
                defaultValue={emailOffers}
              />
            </div>
          </div>
        </HideableBox>
        <h3>Profiles:</h3>
        {profileData.Profiles.map((prof) => {
          count++;
          return (
            <HideableBox
              key={prof.Name}
              label={`: ${prof.Name}  Settings`}
              ClassList="EditSection ProfileSection"
              hiddenByDefault={true}
            >
              <h2>{prof.Name + " Settings"}</h2>
              <div className="EditLineItem">
                <span>Name:</span> <div>{prof.Name}</div>
              </div>
              <div className="EditLineItem">
                <span>Date of Birth (mm dd yyyy):</span>
                <div>
                  {prof.DOB.mm}/{prof.DOB.dd}/{prof.DOB.yyyy}
                </div>
              </div>

              <div className="EditLineItem">
                <span>Current Age:</span>
                <div>{prof.Age}</div>
              </div>

              <div className="EditLineItem">
                <span>Current Gender</span>
                <div>{prof.Gender}</div>
              </div>

              <div className="EditLineItem">
                <span>Colors Selected</span>

                <ProfileImage
                  color={prof.ProfileIMGFG}
                  backgroundColor={prof.ProfileIMGBG}
                />
              </div>
              <br />
              <HideableBox label="Edit Profile">
                <Home
                  editMode={true}
                  arrayIndex={count}
                  user={props.user}
                  userNameKey={props.userNameKey}
                  afterSubmit={afterSubmit}
                  profileData={props.profileData}
                  QDB={props.QDB}
                  defaultName={prof.Name}
                  defaultDOB={prof.DOB}
                  defaultGender={prof.Gender}
                  defaultFG={prof.ProfileIMGFG}
                  defaultBG={prof.ProfileIMGBG}
                />
              </HideableBox>
            </HideableBox>
          );
        })}

        <h3>Legal:</h3>
        <div className="EditButtonSection">
          <LegalDoc
            Dev={props.Dev}
            DocURL="https://qfp-logos.s3.amazonaws.com/legal/EULA+Final.pdf"
          >
            EULA
          </LegalDoc>
          <LegalDoc
            Dev={props.Dev}
            DocURL="https://qfp-logos.s3.amazonaws.com/legal/Privacy+Policy+Draft+Final.pdf"
          >
            Privacy Policy
          </LegalDoc>
          <LegalDoc
            Dev={props.Dev}
            DocURL="https://qfp-logos.s3.amazonaws.com/legal/Terms+of+Use+Final.pdf"
          >
            Terms of Use
          </LegalDoc>
          <LegalDoc
            Dev={props.Dev}
            DocURL="https://qfp-logos.s3.amazonaws.com/legal/Web+site+Disclosure+Notes+Final.pdf"
          >
            Website Disclosure Notes
          </LegalDoc>
        </div>
      </div>
      {/* {props.Dev ? (
        <div id="logButton">
          <button>test</button>
        </div>
      ) : (
        <></>
      )} */}
      {props.Dev ? JSON.stringify(props.profileData) : ""}

      <Popup open={openConfirm} onClose={closeConfirmModal}>
        <div className="header">Are you Sure?</div>
        <div className="modal_content">
          Selecting "Okay" will cancel your subscription, it will remain active
          only until the Expiry date. You will lose access to any Reports after
          the Expiry Date.
          <br />
          This will also refresh the page.
        </div>
        <div className="actions">
          <button
            className="userActionButton button"
            onClick={() => {
              CancelSub();
            }}
          >
            Okay
          </button>
          <button
            className="userActionButton button"
            onClick={() => {
              // console.log("Confirmation modal closed ");
              closeConfirmModal();
            }}
          >
            Cancel
          </button>
        </div>
      </Popup>
    </>
  );
}
